import { render, staticRenderFns } from "./SelectItemWithIcon.vue?vue&type=template&id=8b912648&scoped=true&"
import script from "./SelectItemWithIcon.vue?vue&type=script&lang=js&"
export * from "./SelectItemWithIcon.vue?vue&type=script&lang=js&"
import style0 from "./SelectItemWithIcon.vue?vue&type=style&index=0&id=8b912648&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b912648",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib'
import { VListItem } from 'vuetify/lib'
import { VListItemAction } from 'vuetify/lib'
import { VListItemContent } from 'vuetify/lib'
import { VListItemTitle } from 'vuetify/lib'
installComponents(component, {VCheckbox,VListItem,VListItemAction,VListItemContent,VListItemTitle})
